import axios, { AxiosError } from 'axios';
import { IFeatureFlag } from '../../../interfaces/featureFlag';
import { CommonRootState } from '../../../combineReducers';
import { sendError } from '../../../sendError';
import { ThunkAction } from 'redux-thunk';

const fetchFeatureFlagsRequest = () =>
  ({
    type: 'FETCH_FEATURE_FLAGS_REQUEST'
  } as const);

const fetchFeatureFlagsSuccess = (payload: IFeatureFlag[]) =>
  ({
    type: 'FETCH_FEATURE_FLAGS_SUCCESS',
    payload
  } as const);

const fetchFeatureFlagsFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: 'FETCH_FEATURE_FLAGS_FAILURE',
    error
  } as const;
};

export const fetchFeatureFlags = (): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchFeatureFlagsRequest());

    const response = await axios.get<IFeatureFlag[]>('/spapi/featureFlags');
    dispatch(fetchFeatureFlagsSuccess(response.data));
  } catch (error) {
    dispatch(fetchFeatureFlagsFailure(error));
  }
};

export type Actions =
  | ReturnType<typeof fetchFeatureFlagsRequest>
  | ReturnType<typeof fetchFeatureFlagsSuccess>
  | ReturnType<typeof fetchFeatureFlagsFailure>;
